import { useDispatch, useSelector } from 'react-redux'
import TipEntryModal from '../../../components/TipEntryModal'
import { getVnTipEntryDialog } from '../../Selectors'
import { setVNTipEntryDialog } from '../../ActionCreators'
import { VNInputDialog } from 'vn-react-components/VNComponents/VNInputDialog'

export const VNTipEntryDialog = () => {
  const dialogOptions = useSelector(getVnTipEntryDialog)
  const dispatch = useDispatch()

  if (!dialogOptions?.get('open')) {
    return
  }

  if (dialogOptions?.get('isCfd')) {
    return (
      <VNInputDialog
        open={dialogOptions?.get('open')}
        title={dialogOptions?.get('title')}
        onSave={dialogOptions?.get('onSubmit')}
        onClose={() => dispatch(setVNTipEntryDialog(false))}
        money
        fullWidth
        closeOnSave
        endAdornment
        width={'480px'}
      />
    )
  }

  return (
    <TipEntryModal
      key="custom"
      title={dialogOptions?.get('title')}
      isKiosk={dialogOptions?.get('isKiosk')}
      initialValue={dialogOptions?.get('initialValue')}
      saveButtonText={dialogOptions?.get('saveButtonText') || 'Save'}
      onClose={() => dispatch(setVNTipEntryDialog(false))}
      onSubmit={dialogOptions?.get('onSubmit')}
    />
  )
}
